import { makeAutoObservable, runInAction } from "mobx"

export type ProductData = {
  ProductID: string,
  PriceID: string,
  ProductName: string,
  UnitAmount: number,
  Currency: string,
}

export type IpData = {
  success: boolean,
  country_code?: string,
}

export type SendMailResponse = { Success: boolean, WaitTime?: number };

export class GlobalStore {
  products: ProductData[] = [];
  loading = false;

  ip: IpData = { success: false }
  loading_ip = false;

  currency: "brl" | "usd" = "brl";

  sending = false;
  send_state: SendMailResponse | null = null;

  constructor() {
    makeAutoObservable(this)
  }

  async getProducts(product?: string) {
    try {
      this.loading = true;
      const params = (product)
        ? "?" + new URLSearchParams({ product: product! })
        : "";
      const resp = await fetch("/api/products" + params)
      const data = await resp.json();
      runInAction(() => {
        this.products = data;
        this.loading = false;
      });
    } catch (e) { }
  }

  async setCurrency(currency: "brl" | "usd") {
    this.currency = currency;
  }

  async getIP() {
    try {
      this.loading_ip = true;
      const resp = await fetch("/api/ip");
      const data = await resp.json();
      runInAction(() => {
        this.ip = data;
        this.loading_ip = false;

        if (!data || !data.success) {
          this.currency = "brl";
          return;
        }

        switch (data.country_code) {
          case "BR":
            this.currency = "brl";
            break;
          default:
            this.currency = "usd";
        }
      });
    } catch (e) { }
  }

  async sendMail(intent_id: string) {
    try {
      this.sending = true;
      const resp = await fetch("/api/sendmail", { method: "POST", body: JSON.stringify({ IntentID: intent_id }) });
      const data = await resp.json() as SendMailResponse;
      runInAction(() => {
        this.send_state = data;
        this.sending = false;
      });
    } catch (e) {

    } finally {
      runInAction(() => {
        this.sending = false;
      });
    }
  }
}

export const globalStore = new GlobalStore()
